//by:hansan
//
//
//im 授权
export const permission = "/auth/permission";
//IM管理-->安全设置页面数据显示接口
export const getAccountSafeSetting = "/safeSettings/getAccountSafeSetting";
//IM管理-->安全设置页面保存接口
export const saveAccountSafeSetting = "/imSysWechatAccountSafeConfig/saveAccountSafeSetting";
//查询机构微信账号分页列表
export const findSysWechatAccountPageList = "/sys/wechat-account/findSysWechatAccountPageList";
//判断设备号是否重复
export const judgeRepeatIMEL = "sys/wechat-account/judgeRepeatIMEL";
//判断手机号是否重复
export const judgeRepeatMobile = "/sys/wechat-account/judgeRepeatMobile"
//删除好友
export const delWechatContactinfo = "/sys/wechat-account/delWechatContactinfo";
//IM管理-->标签管理设置数据显示接口
export const getFriendTag ="/friendTagSetting/getFriendTag"



//外呼
//获取可用电话服务商接口
export const getAvailablePhoneServices = "/softPhone/getAvailablePhoneServices";
//软电话外呼接口
export const softPhoneMakeCall = "/softPhone/softPhoneMakeCall";
//挂机
export const softPhoneHungUp = "/softPhone/softPhoneHungUp";
//获取用户在线状态接口（注意用户session失效时，不要再循环调用，否则会导致服务端此用户在线状态一直为空闲状态）
export const getUserOnlineStatus = "/userOnlineStatus/getUserOnlineStatus";
//更新用户在线状态
export const updateUserOnlineStatus = "/userOnlineStatus/updateUserOnlineStatus";
//获取通话状态
export const getCallState = "/softPhone/getCallState";
// 置顶删除会话
export const setChatSession = "/chat/setChatSession"


//消息
//获取最近5条未读消息数列表
export const getUnReadList = "/separate/userMsg/getUnReadList";
//设置消息已读
export const reads = "/separate/userMsg/reads"
//获取全部未读消息
export const getUnReadCount = "/separate/userMsg/getUnReadCount"

/* IM界面接口 */
//获取会话列表
export const chatSessionList = "/chat/chatSessionList";
//获取好友列表
export const chatFriendList = "/chat/chatFriendList";
//点击开始聊天
export const checkWeChatMsg = "/chat/checkWeChatMsg";
//获取好友信息
export const friendInfo = "/chat/friendInfo";
//修改备注
export const editWechatContactinfoRemark = "/sys/wechat-account/editWechatContactinfoRemark"
//查询聊天记录
export const findHistoryWechatMessage = "/chat/findHistoryWechatMessage"
//选择工单聊天记录
export const chooseChatRecord = "/chat/chooseChatRecord"
//聊天页面---->工单已关联聊天记录接口
export const getMessageOutsideRelations = "/chat/getMessageOutsideRelations"
//聊天页面---->crm工单已关联聊天记录接口
export const getMsgOutsideRelationCount = "/chat/getMsgOutsideRelationCount"
//聊天页面---->聊天信息关联第三方跟单id接口
export const saveMessageOutsideRelations = "/chat/saveMessageOutsideRelations"
//查询微信和好友 基本数据
export const findWechatAndFriend = "/sys/wechat-account/findWechatAndFriend"
//pc端添加微信好友
export const pcAddWxFriends = "/sys/wechat-account/pcAddWxFriends"
//pc端添加微信好友新接口
export const friendVerification = "/sys/wechat-account/friendVerification"
//微信管理页面获取聊天记录
export const findManagePageWechatMessage = "/sys/wechat-account/findManagePageWechatMessage"
//获取OSS上传配置
export const getOssConfigInfo = "/oss/getOssConfigInfo"
//修改好友标签
export const editFriendTag = "/chat/editFriendTag"
//查看上下文
export const findMessageRecordContext = "/sensitiveWords/findMessageRecordContext"
//搜索聊天记录：返回符合条件的联系人
export const searchMessageContactinfo = "/chat/searchMessageContactinfo"
//搜索聊天记录：查询符合条件的联系人的聊天记录 /chat/searchMessage
export const searchMessage = "/chat/searchMessage"
// 多条敏感词
export const chatcheckSensitiveWord = "/chat/checkSensitiveWord"

// 话术库
// 话术库
// 删除话术库分组数据
export const deleteDiscourseGroup = "/templateStatement/deleteDiscourseGroup";
//删除话术模版
export const deleteTemplateStatement = "/templateStatement/deleteTemplateStatement"
//获取机构组织结构
export const findCompanyGroup = "/templateStatement/findCompanyGroup";
//获取机构组织结构下的客户经理
export const findCompanyGroupOfUser = "/templateStatement/findCompanyGroupOfUser";
//获取单个话术模版数据
export const findTemplateStatementById = "/templateStatement/findTemplateStatementById";
//获取话术模版列表
export const findTemplateStatementPage = "/templateStatement/findTemplateStatementPage";
//管理列表获取话术库分组数据
export const getDiscourseGroup = "/templateStatement/getDiscourseGroup";
//添加话术库分组数据
export const insertDiscourseGroup = "/templateStatement/insertDiscourseGroup";
//添加话术模版
export const insertTemplateStatement = "/templateStatement/insertTemplateStatement";
//搜索页面获取话术库分组数据
export const searchDiscourseGroup = "/templateStatement/searchDiscourseGroup";
//搜索获取话术库数据
export const searchTemplateStatementPage = "/templateStatement/searchTemplateStatementPage";
//话术库分组排序
export const sortDiscourseGroup = "/templateStatement/sortDiscourseGroup";
//更新话术库分组数据
export const updateDiscourseGroup = "/templateStatement/updateDiscourseGroup";
//更新话术模版
export const updateTemplateStatement = "/templateStatement/updateTemplateStatement"

//红包监控导出
export const exportRedPackageMonitor = "/redPackageMonitor/exportRedPackageMonitor";
//红包监控列表
export const redPackageMonitorData = "/redPackageMonitor/redPackageMonitorData";

//语音视频监控导出
export const exportWechatAvMonitor = "/wechatAvMonitor/exportWechatAvMonitor";
//语音视频监控列表
export const findWechatAvMonitorPageList = "/wechatAvMonitor/findWechatAvMonitorPageList";


//获取统计指标原始设置
export const getOldStaticSet = "/statisticalIndicators/getStatisticalIndicators";
export const saveStaticSet = "/statisticalIndicators/saveStatisticalIndicators";

// 敏感词
// 关键词 新增
export const addSensitiveWords = "/sensitiveWords/addOrUpdateSensitiveWords/add";
// 关键词 修改
export const updateSensitiveWords = "/sensitiveWords/addOrUpdateSensitiveWords/update";
// 批量和单次操作敏感词
export const batchOperate = "/sensitiveWords/batchOperate";
// 判断是否可以上传敏感词
export const checkUploadSensitiveWords = "/sensitiveWords/checkUploadSensitiveWords";
// 实时查询，上传文件是否完成
export const findUploadSensitiveWordsLogId = "/sensitiveWords/findUploadSensitiveWordsLogId";
// 删除导出记录;
export const delFailSensitiveWordsImportLog = "/sensitiveWords/delFailSensitiveWordsImportLog";
// 新增敏感词组
export const addWordsGroup = "/sensitiveWords/editWechatSensitiveWordsGroup/add";
// 修改敏感词组
export const updateWordsGroup = "/sensitiveWords/editWechatSensitiveWordsGroup/update";
// 删除敏感词组
export const deleteWordsGroup = "/sensitiveWords/editWechatSensitiveWordsGroup/delete";
// 查询分组列表
export const findWechatSensitiveWordsGroupList = "/sensitiveWords/findWechatSensitiveWordsGroupList";
// 查询模板地址
export const findTemplateAddress = "/sensitiveWords/findTemplateAddress";
// 查询敏感词列表
export const findWechatSensitiveWordsList = "/sensitiveWords/findWechatSensitiveWordsList";
// 敏感词监控列表
export const findWechatSensitiveWordsMonitorList = "/sensitiveWords/findWechatSensitiveWordsMonitorList";
// 查询失败的敏感词下载地址
export const queryFailSensitiveWordsExl = "/sensitiveWords/queryFailSensitiveWordsExl";
// 上传敏感词;
export const uploadSensitiveWordsTwo = "/sensitiveWords/uploadSensitiveWords";
//敏感词发送监控
export const messageSensitiveCheck = '/chat/messageSensitiveCheck';
/*
* 朋友圈使用接口
* */
//查询微信号所有分组
export const wetchatAllGroup='/sysWechatAccountGroup/findSysWechatAccountGroupList';
//查询当前分组下的所有微信号
export const getGroupWechat='/circleFriendsTask/findSysWeChatDivByGroupId';
//发朋友圈接口
export const sendFriendCircle='/circleFriendsTask/creatCircleFriendsTask';
//朋友圈定时任务数据列表
export const getTimingCircleData='/circleFriendsTask/findCircleFriendsTaskList';
//朋友圈任务详情
export const getCircleDetail='/circleFriendsTaskDetail/findCircleFriendsTaskDetail';
//微信号搜索
export const searchWechat='/circleFriendsTask/findByNiceNameOrWechatAccount';
//个人查看朋友圈，查询绑定的微信号接口是findSysWechatAccountPageList
export  const circleWechatList='/sys/wechat-account/findSaleBindWx';//这个是查询销售绑定微信号
//个人查看朋友圈，朋友圈列表
export const getFrontCircle='/circleInformation/searchCircleInformation';
//朋友圈点赞
export const circleGivePraise='/circleLike/sendCircleLike';
//朋友圈评论，回复
export const circleCommentRelay='/circleComment/sendCircleCommentReply';


// 群发
export const searchGroupSendTaskList ='/groupSendTask/searchGroupSendTaskList';//群发任务列表查询
export const delOrCancelGroupSendTask ='/groupSendTask/delOrCancelGroupSendTask';//群发删除
export const taskDetail = '/groupSendTaskPerson/taskDetail';//群发详情
export const searchExecuteGroupSendTaskResult = '/groupSendTask/searchExecuteGroupSendTaskResult';//执行结果
export const searchUsers = '/groupSendTask/searchUsers';//群发查询员工
export const saveGroupSendTask = '/groupSendTask/saveGroupSendTask'//创建群发任务接口
export const checkSensitiveWord = '/groupSendTask/checkSensitiveWord' //校验敏感词

//个人
export const delPersonalTask = '/groupSendTaskPerson/delPersonalTask';//
export const sendFriendResultList = '/groupSendTaskPerson/sendFriendResultList';
export const findMyGroupSendTaskPageList = '/groupSendTask/findMyGroupSendTaskPageList';
export const createPersonalGroupSendTask = '/groupSendTask/createPersonalGroupSendTask';
// 销售创建群发任务
// 我的任务--->>查询列表
export const findMyTaskPageList = '/groupSendTask/findMyTaskPageList';
// 查看执行结果
export const sendFriendResultContent = '/groupSendTaskPerson/sendFriendResultContent';
// 创建群发任务---->好友列表
export const taskFriendList = '/groupSendTaskPerson/taskFriendList';
// 创建群发任务---->查看任务内容
// export const taskDetail = '/groupSendTaskPerson/taskDetail';
// 查询销售已绑定的设备
export const findSaleBindWx = '/sys/wechat-account/findSaleBindWx';
// 创建群发任务接口
export const executeBackstageGroupSendTask = '/groupSendTask/executeBackstageGroupSendTask';
// 查看执行结果 || 发送详情(已发送好友列表)
// export const sendFriendResultList = '/groupSendTaskPerson/sendFriendResultList';


//商户固码
export const openPayStatus = '/apiPayOrder/openPayStatus'    // post请求   获取是否显示菜单按钮
export const payCodeInfo = '/apiPayOrder/payCodeInfo'        //post请求 获取二维码背景, 链接,

// 清粉
export const findWeChatAccount = '/removePowder/findWeChatAccountByGroupAndAuthority'  //post请求 获取分组下的微信号列表,
export const findRemovePowderTask = '/removePowder/findRemovePowderTask' //清粉任务列表 不分页
export const deleteRemovePowderTask = '/removePowder/deleteRemovePowderTask' //删除清粉任务
export const executePowderTask = '/removePowder/executePowderTask' //执行清粉任务
export const exportRemovePowderTaskDetails = '/removePowder/exportRemovePowderTaskDetails' //导出详情
export const findRemovePowderTaskDetails = '/removePowder/findRemovePowderTaskDetails' //清粉任务列表详情
export const batchDeleteFriend = '/sys/wechat-account/batchDeleteFriend' //批量删除好友
export const checkIsFriend = '/sys/wechat-account/checkIsFriend' //校验是不是好友
export const findSaleBindWeChatAccount = '/sys/wechat-account/findSaleBindWeChatAccount' //分组列表
export const checkHasPublicFriends = '/chat/checkHasPublicFriends'
// 转发消息
export const relayMessage = '/chat/relayMessage'
// 不加密导出获取审批人
export const getShortMessageApprovedByList = '/chat/getShortMessageApprovedByList'
// 发送短信给审批人
// export const sendShortMessageToAuditor = '/im-business/sys/wechat-account/sendShortMessageToAuditor'




// WEBPACK FOOTER //
// ./src/utils/api-im.js